define('GameDayCore/GDUtil/resources/GDConfig',['require','exports','module','extant/extant'],function(require,exports,module) {
	var exists = require("extant/extant");
	var instance;

	function GDConfig() {
		this.initProps = null;
		this.dataSourceConfig = null;
		this.env = "";
		this.dictionary = {};
		this.supportedVideo = ["FLASH_1200K_640X360"];
		this.passiveMode = false;
	};

	function getInstance() {
		if (!exists(instance)) {
			instance = new GDConfig();
		}
		return instance;
	}

	return getInstance();
});
